var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mdc-top-app-bar__section",class:{
    'mdc-top-app-bar__section--align-start':_vm.alignStart,
    'mdc-top-app-bar__section--align-end':_vm.alignEnd,
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }